export default __webpack_public_path__ + "static/3-486c9cc3084465656caf06b2021d3092.jpg";